import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import roleChooserReducer from './roleChooser/roleChooserSlice';
import configReducer from './config/configSlice';
import dataApi from '../Requests/dataApiSlice'
import { roleApi } from '../Requests/roleApiSlice';

export const appStore = configureStore({
    reducer: {
        auth: authReducer,
        role: roleChooserReducer,
        config: configReducer,
        [dataApi.reducerPath]: dataApi.reducer,
        [roleApi.reducerPath]: roleApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false //TODO: This is a workaround. Need to figure out why state entries are non-serializable. 
    }).concat(dataApi.middleware, roleApi.middleware)
});

export type AppStore = typeof appStore;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];